import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { ADMIN_HOME_ROUTE } from "features/home/home-routes";
import {
	Page,
	PageContent,
	ScrollToTopOnMount,
	PageHeaderAddButton
} from "frame/components";
import LeaveTypeListing from "./leave-type-listing";
import LeaveTypeModal from "./leave-type-modal";

const useStyles = makeStyles((theme) => ({
	root: {},
	body: {
		marginTop: theme.spacing(2),
		[theme.breakpoints.down("xs")]: {
			marginTop: theme.spacing(3),
		},
	},
}));

const LeaveType = ({
	leaveTypes,
	isLoadingList,
	onList,
	onAdd,
	onSave,
	onRemove
}) => {
	const classes = useStyles();

	const sortedLeaveTypes = useMemo(
		() => [...leaveTypes].sort((a, b) => (b.active ? 1 : 0) - (a.active ? 1 : 0)),
		[leaveTypes]
	);

	const [selectedLeaveType, setSelectedLeaveType] = useState();
	const [showAddLeaveTypeModal, setShowAddLeaveTypeModal] = useState(false);

	const onLeaveTypeEdit = (leaveTypeId) => {
		setSelectedLeaveType({
			...leaveTypes.find(lt => lt.id === leaveTypeId)
		});
		setShowAddLeaveTypeModal(true);
	};

	const onLeaveTypeDelete = (leaveTypeId) => {
		onRemove(leaveTypeId);
	};

	const onModalSave = (leaveType) => {
		if (leaveType.id) {
			onSave(leaveType);
		}
		else {
			onAdd(leaveType);
		}
		setShowAddLeaveTypeModal(false);
	};

	useEffect(() => {
		onList();
	}, [onList]);

	return (
		<Page className={classes.root} title="Leave Type">
			<ScrollToTopOnMount />
			<PageHeaderAddButton
				title="Leave Type"
				addTabTitle="Add Leave Type"
				onAdd={() => {
					setSelectedLeaveType(undefined);
					setShowAddLeaveTypeModal(true);
				}}
				staffUserHide={false}
				backActionPath={ADMIN_HOME_ROUTE}
			/>
			<PageContent pad>
				<div className={classes.body}>
				<LeaveTypeListing
					leaveTypes={sortedLeaveTypes}
					isLoading={isLoadingList}
						onEdit={onLeaveTypeEdit}
						onDelete={onLeaveTypeDelete}
					/>
				</div>
			</PageContent>
			<LeaveTypeModal
				leaveType={selectedLeaveType}
				isOpen={showAddLeaveTypeModal}
				onSubmit={onModalSave}
				onClose={() => setShowAddLeaveTypeModal(false)}
			/>
		</Page>
	);
};

LeaveType.propTypes = {
	leaveTypes: PropTypes.array.isRequired,
	isLoadingList: PropTypes.bool.isRequired,
	onList: PropTypes.func.isRequired,
	onAdd: PropTypes.func.isRequired,
	onSave: PropTypes.func.isRequired,
	onRemove: PropTypes.func.isRequired
};

export default LeaveType;
